import keymirror from 'keymirror';
import { questionTypes } from 'sharedParts';

const surveyBlockMorphList = [
  {
    value: questionTypes.questionDropdown,
    label: 'Dropdown',
  },
  {
    value: questionTypes.questionMulti,
    label: 'Multichoice',
  },
  {
    value: questionTypes.questionScale,
    label: 'Scale',
  },
  {
    value: questionTypes.questionNumeric,
    label: 'Numeric',
  },
  {
    value: questionTypes.questionSingle,
    label: 'Single',
  },
  {
    value: questionTypes.shortText,
    label: 'Short text',
  },
  {
    value: questionTypes.longText,
    label: 'Long text',
  },
];

export const matrixMorphList = [
  {
    value: questionTypes.questionMatrixRadio,
    label: 'Matrix',
    subType: 'Single',
    primary: true,
  },
  {
    value: questionTypes.questionMatrixMulti,
    label: 'Matrix',
    subType: 'Multi',
  },
  {
    value: questionTypes.questionMatrixScale,
    label: 'Matrix',
    subType: 'Scale',
  },
];

export const imageMorphList = [
  {
    value: questionTypes.questionImageMulti,
    label: 'Image',
    subType: 'Multi',
  },
  {
    value: questionTypes.questionImageSingle,
    label: 'Image',
    subType: 'Single',
    primary: true,
  },
];

const groupType = keymirror({
  matrix: null,
  image: null,
  respondent: null,
});

const addGroupType = type => item => {
  item.groupType = type;
  return item;
};

export const multiTypeMorphList = [
  ...matrixMorphList.map(addGroupType(groupType.matrix)),
  ...imageMorphList.map(addGroupType(groupType.image)),
];

const customQuestionTypeList = [
  {
    value: questionTypes.respondentInfoMulti,
    subType: 'Multi select',
    label: 'Custom',
    primary: true,
  },
  {
    value: questionTypes.respondentInfoRadio,
    subType: 'Single select',
    label: 'Custom',
  },
  {
    value: questionTypes.respondentInfoLongText,
    subType: 'Long text',
    label: 'Custom',
  },
  {
    value: questionTypes.respondentInfoShortText,
    subType: 'Short text',
    label: 'Custom',
  },
  {
    value: questionTypes.respondentInfoDropdown,
    subType: 'Dropdown',
    label: 'Custom',
  },
];

export const respondentSubTypeMorphList = customQuestionTypeList.map(
  addGroupType(groupType.respondent),
);

export const respondentBlockMorphList = [
  {
    value: questionTypes.respondentCompanyName,
    label: 'Company',
  },
  {
    value: questionTypes.respondentFirstName,
    label: 'First name',
  },
  {
    value: questionTypes.respondentLastName,
    label: 'Last name',
  },
  {
    value: questionTypes.respondentPhone,
    label: 'Phone',
  },
  {
    value: questionTypes.respondentMail,
    label: 'Email',
  },
  {
    value: questionTypes.respondentBlankField,
    label: 'Blank',
  },
];

export default surveyBlockMorphList;
